import React from 'react';

function IdealCard(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="20" viewBox="0 0 32 20" {...props}>
      <path
        d="M29.6159726,0.500069536 C30.1145752,0.495886197 30.5950536,0.680218729 30.9469175,1.01491903 C31.2967569,1.3485237 31.4969409,1.79823123 31.5,2.26594503 L31.5000356,17.7410067 C31.4942156,18.2288558 31.2820848,18.6675724 30.9471212,18.9841043 C30.6049799,19.307419 30.1350077,19.5039917 29.6158625,19.4999193 L2.38282468,19.4999356 C1.8843102,19.5039598 1.40666423,19.3191384 1.05249967,18.9845393 C0.703941317,18.6532257 0.504221501,18.20188 0.5,17.7340682 L0.499979665,2.26787385 C0.504217592,1.79799581 0.704073146,1.34824001 1.05445801,1.01619606 C1.405547,0.681373971 1.88464924,0.496758326 2.38549911,0.500087134 Z"
        stroke="#DDDDDD"
        fill="#FFFFFF"
        fillRule="nonzero"
      />
      <g fillRule="evenodd" transform="translate(7, 2)">
        <path
          d="M0,2.75 C0,1.23121694 1.23121694,0 2.75,0 L10,0 C14.418278,0 18,3.581722 18,8 C18,12.418278 14.418278,16 10,16 L2.75,16 C1.23121694,16 0,14.7687831 0,13.25 L0,2.75 Z"
          fill="#FFFFFF"
        />
        <path
          d="M4.433,7.516 C5.04769293,7.516 5.546,7.01769293 5.546,6.403 C5.546,5.78830707 5.04769293,5.29 4.433,5.29 C3.81830707,5.29 3.32,5.78830707 3.32,6.403 C3.32,7.01769293 3.81830707,7.516 4.433,7.516 Z M5.273,12.0040012 C4.8261209,12.0045311 4.39737753,11.8273127 4.08129228,11.5114151 C3.76520703,11.1955174 3.58773416,10.7668793 3.5879997,10.32 L3.5879997,9.004 C3.5879997,8.53731939 3.96631939,8.159 4.433,8.159 C4.89968061,8.159 5.278,8.53731939 5.278,9.004 L5.278,12.0040012 L5.273,12.0040012 L5.273,12.0040012 Z"
          fill="#000000"
          fillRule="nonzero"
        />
        <path
          d="M1,2.75 C1,1.784 1.784,1 2.75,1 L10,1 C13.8659932,1 17,4.13400675 17,8 C17,11.8659932 13.8659932,15 10,15 L2.75,15 C1.78350169,15 1,14.2164983 1,13.25 L1,2.75 Z M2.75,2 C2.33578644,2 2,2.33578644 2,2.75 L2,13.25 C2,13.664 2.336,14 2.75,14 L10,14 C13.3137085,14 16,11.3137085 16,8 C16,4.68629154 13.3137085,2 10,2 L2.75,2 Z"
          fill="#000000"
        />
        <path
          d="M6.55,4.56 L6.55,12 L9.788,12 C12.728,12 14.002,10.34 14.002,7.991 C14.002,5.744 12.727,4 9.788,4 L7.11,4 C6.80078565,4.00054825 6.55009992,4.25078712 6.549,4.56 L6.55,4.56 Z"
          fill="#E60073"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default IdealCard;
